import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const StatusFilter = ({ setStatus, value }) => {
  const options = [
    {
      label: 'PENDING',
      value: '0',
    },
    {
     label: 'ACCEPTED',
     value: '1'
    },
    {
     label: 'REJECTED',
     value: '-1'
    }
  ]
  const onChange = checkedValues => {
    setStatus(checkedValues)
  }
  return (
    <FilterCheckBoxComp options={options} value={value} onChange={onChange} />
  )
}

export default StatusFilter
